'use client';

import {usePathname} from 'next/navigation';
import {useEffect, useRef} from 'react';
import '@website/lib/analytics/linkedin';

/**
 * In Next.js, navigations to /gallery, /experiences, etc. are client-side:
 * no full reload, so LinkedIn's tag only fires on the first load (home).
 * This component calls lintrk('track') on every route change so each
 * "page" sends a page view to LinkedIn.
 */
export function LinkedInRouteChangeTracker() {
  const pathname = usePathname();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (typeof window === 'undefined' || !window.lintrk) return;
    window.lintrk('track');
  }, [pathname]);

  return null;
}
